import React from 'react';
import 'layout/layout.scss';
import Navbar from 'components/Navbar/Navbar';
import DellNavbar from 'components/Navbar/DellNavbar';

import Footer from 'components/Footer/Footer';
import { useRootState } from 'store/StateProvider';

const Layout = ({ children }) => {
    const {
        auth: { isDellUser },
    } = useRootState();

    return (
        <div className="layout">
            {isDellUser ? <DellNavbar /> : <Navbar />}
            {children}
            <div className="footer-wrapper">
                <Footer isDellUser={isDellUser} />
            </div>
        </div>
    );
};
export default Layout;
